import { render, staticRenderFns } from "./order-confirmed.vue?vue&type=template&id=0ff42ee5"
import script from "./order-confirmed.vue?vue&type=script&lang=ts"
export * from "./order-confirmed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff42ee5')) {
      api.createRecord('0ff42ee5', component.options)
    } else {
      api.reload('0ff42ee5', component.options)
    }
    module.hot.accept("./order-confirmed.vue?vue&type=template&id=0ff42ee5", function () {
      api.rerender('0ff42ee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/order-confirmed.vue"
export default component.exports